import Seo from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { CTARow } from "@/components/CTA";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SITE } from "@/data/site";
import { FAQS } from "@/data/faqs";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function FaqPage() {
  return (
    <>
      <Seo
        title="Frequently Asked Questions | Travel Passport and Visa LLC"
        siteName={SITE.siteName}
        description="Answers about passport assistance, visa services, fees, processing times, and how Travel Passport and Visa LLC — a private service provider — can help. Call 866-334-8472."
        jsonLd={jsonLd}
      />
      <section className="grain bg-navy py-16 lg:py-24" data-testid="faq-hero">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <span className="inline-block rounded-full border border-gold/40 px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.25em] text-gold">
            Private Service Provider
          </span>
          <h1 className="mt-5 max-w-3xl font-display text-4xl font-bold tracking-tight text-white sm:text-5xl" data-testid="faq-h1">
            Frequently Asked Questions
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-slate-300 sm:text-lg">
            Straight answers about our services, fees, processing times, and who we are.
          </p>
        </div>
      </section>
      <section className="bg-white py-16 lg:py-24">
        <div className="mx-auto max-w-4xl px-4 sm:px-6">
          <Reveal>
            <Accordion type="single" collapsible data-testid="faq-page-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`fp-${i}`} data-testid={`faq-page-item-${i}`}>
                  <AccordionTrigger className="text-left font-display text-base font-semibold text-navy hover:text-gold-dark">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm leading-relaxed text-slate-600">{f.a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
            <div className="mt-12 rounded-2xl bg-slate-50 p-8 text-center" data-testid="faq-cta-card">
              <h2 className="font-display text-xl font-bold text-navy">Still Have Questions?</h2>
              <p className="mx-auto mt-2 max-w-md text-sm text-slate-600">
                Call our team or submit the form — we'll help you understand your options.
              </p>
              <CTARow className="mt-6 justify-center" testPrefix="faq-page" />
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
